var _defs, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradWarn",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fcd34d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f59e0b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadowWarn"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 5,
    stdDeviation: 4,
    floodColor: "#d97706",
    floodOpacity: 0.5
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 50 15 L 10 85 L 90 85 Z",
    fill: "url(#gradWarn)",
    filter: "url(#shadowWarn)",
    stroke: "#d97706",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 50 35 L 50 60",
    fill: "none",
    stroke: "#78350f",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 75,
    r: 4,
    fill: "#78350f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.96749fb280f3e17e4135c49bd6e9e592.svg";
export { ForwardRef as ReactComponent };